import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Card, Button, CardDeck } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 4, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

function NearKualaLumpur() {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1366 });
  const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 });
  const isMobileDevice = useMediaQuery({ maxDeviceWidth: 767 });
  const isTabletDevice = useMediaQuery({
    minDeviceWidth: 768,
    maxDeviceWidth: 1224,
  });

  const [showCarousel, setShowCarousel] = useState(true);

  // Function to Hide Carousel Items
  const hideCarouselItems = () => {
    setShowCarousel(false);
  };

  // Function to Show Carousel Items
  const showCarouselItems = () => {
    setShowCarousel(true);
  };

  const [itemsData, setItemsData] = useState([
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
    {
      itemDesc:
        "Some quick example text to build on the card title and make up the",
    },
  ]);

  return (
    <div>
      {isDesktopOrLaptop && (
        <h1 style={{ color: "#E72129", fontWeight: "bold", marginLeft: 65 }}>
          Near Kuala Lumpur
        </h1>
      )}
      {isTabletDevice && (
        <h1 style={{ color: "#E72129", fontWeight: "bold", marginLeft: 65 }}>
          Near Kuala Lumpur
        </h1>
      )}
      {isMobileDevice && (
        <h2
          style={{
            color: "#E72129",
            fontWeight: "bold",
            // marginLeft: 65,
            textAlign: "center",
          }}
        >
          Near Kuala Lumpur
        </h2>
      )}

      <br />
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            background: "#F5F5F9",
            width: "93.5%",
            justifyContent: "center",
            display: "inline-block",
            borderRadius: 40,
          }}
        >
          {showCarousel ? (
            <div>
              <Carousel
                //   centerMode={true}
                swipeable={false}
                draggable={false}
                //   showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                //   autoPlay={this.props.deviceType !== "mobile" ? true : false}
                autoPlaySpeed={1000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                //   removeArrowOnDeviceType={["tablet", "mobile"]}
                //   deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                {itemsData.map((item) => {
                  return (
                    <div>
                      <br />
                      <br />
                      <div className="col d-flex justify-content-center">
                        <Card style={{ width: "18rem", borderRadius: 40 }}>
                          <Card.Img
                            style={{
                              borderTopLeftRadius: 40,
                              borderTopRightRadius: 40,
                              height: 140,
                            }}
                            variant="top"
                            src="https://cdn.thecrazytourist.com/wp-content/uploads/2018/08/ccimage-shutterstock_571221049.jpg"
                          />
                          <Card.Body
                            style={{
                              backgroundColor: "#E72129",
                              borderBottomLeftRadius: 40,
                              borderBottomRightRadius: 40,
                            }}
                          >
                            <Card.Text style={{ color: "white" }}>
                              {item.itemDesc}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                        <br />
                        <br />
                      </div>
                      <br />
                      <br />
                    </div>
                  );
                })}
                <br />
              </Carousel>
              <div className="text-center">
                <Button
                  onClick={hideCarouselItems}
                  variant="#E72129"
                  style={{
                    backgroundColor: "#E72129",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: 20,
                    width: 190,
                    borderRadius: 15,
                  }}
                >
                  View All
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <br />
              <br />
              <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-6">
                {itemsData.map((item) => {
                  return (
                    <div
                      className="col d-flex justify-content-center"
                      style={{ paddingBottom: 35 }}
                    >
                      <div
                        className="card"
                        style={{ width: "18rem", borderRadius: 40 }}
                      >
                        <img
                          src="https://cdn.thecrazytourist.com/wp-content/uploads/2018/08/ccimage-shutterstock_571221049.jpg"
                          className="card-img-top"
                          alt="..."
                          style={{
                            borderTopLeftRadius: 40,
                            borderTopRightRadius: 40,
                            height: 140,
                          }}
                        />
                        <div
                          className="card-body"
                          style={{
                            backgroundColor: "#E72129",
                            borderBottomLeftRadius: 40,
                            borderBottomRightRadius: 40,
                          }}
                        >
                          <p className="card-text" style={{ color: "white" }}>
                            {item.itemDesc}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center">
                <br />
                <Button
                  onClick={() => {
                    showCarouselItems();
                  }}
                  variant="#E72129"
                  style={{
                    backgroundColor: "#E72129",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: 20,
                    width: 190,
                    borderRadius: 15,
                  }}
                >
                  View Less
                </Button>
              </div>
            </div>
          )}

          <br />
          <br />
        </div>
      </div>

      {/* </div> */}
      {/* </div> */}
    </div>
  );
}

export default NearKualaLumpur;
